import type { SVGProps } from "react";
import { memo } from "react";
const CloudDirectory = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80" {...props}>
    <defs>
      <linearGradient id="prefix__a" x1="0%" x2="100%" y1="100%" y2="0%">
        <stop offset="0%" stopColor="#4D27A8" />
        <stop offset="100%" stopColor="#A166FF" />
      </linearGradient>
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="url(#prefix__a)" d="M0 0h80v80H0z" />
      <path
        fill="#FFF"
        d="M50 58.031c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m-8-2c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2m-10 0c0 1.103-.897 2-2 2s-2-.897-2-2 .897-2 2-2 2 .897 2 2m4-19c0-2.206 1.794-4 4-4s4 1.794 4 4-1.794 4-4 4-4-1.794-4-4m15 15.142v-5.142a1 1 0 0 0-1-1h-9v-3.09c2.833-.479 5-2.943 5-5.91 0-3.309-2.691-6-6-6s-6 2.691-6 6c0 2.967 2.167 5.431 5 5.91v3.09h-9a1 1 0 0 0-1 1v5.142c-1.721.447-3 2-3 3.858 0 2.206 1.794 4 4 4s4-1.794 4-4c0-1.858-1.279-3.411-3-3.858v-4.142h8v4.142c-1.721.447-3 2-3 3.858 0 2.206 1.794 4 4 4s4-1.794 4-4c0-1.858-1.279-3.411-3-3.858v-4.142h8v4.142c-1.721.447-3 2-3 3.858 0 2.206 1.794 4 4 4s4-1.794 4-4c0-1.858-1.279-3.411-3-3.858M40 65.031c-9.691 0-17-2.149-17-5V23.426c3.322 2.478 10.268 3.636 16.852 3.636 6.71 0 13.787-1.166 17.148-3.661v36.63c0 2.851-7.309 5-17 5M39.852 15C50.109 15 57 17.601 57 20.031s-6.891 5.031-17.148 5.031C29.771 25.062 23 22.461 23 20.031S29.771 15 39.852 15m0-2c-9.08 0-18.851 2.2-18.852 7.031v40c0 5.161 9.814 7 19 7s19-1.839 19-7v-40C59 15.2 49.074 13 39.852 13"
      />
    </g>
  </svg>
);
const Memo = memo(CloudDirectory);
export default Memo;
